import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (err) => {
    const cfg = err.config || {};
    const url = cfg.url || "";
    if (err.response?.status === 401 && !cfg._retry && (url.startsWith("/owner") || url.startsWith("/admin"))) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(err);
  }
);

export function errMsg(e, fallback = "Something went wrong. Please try again or call us.") {
  const d = e?.response?.data?.detail;
  if (!e?.response) return "We couldn't reach our server. Check your connection, or call or text us.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ") || fallback;
  return fallback;
}

export function captureUtm() {
  const p = new URLSearchParams(window.location.search);
  const keys = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content"];
  if (keys.some((k) => p.get(k)) || !sessionStorage.getItem("op_utm")) {
    const utm = {};
    keys.forEach((k) => p.get(k) && (utm[k] = p.get(k)));
    if (document.referrer && !document.referrer.includes(window.location.host)) utm.referrer = document.referrer.slice(0, 100);
    sessionStorage.setItem("op_utm", JSON.stringify(utm));
  }
  if (!sessionStorage.getItem("op_sid")) sessionStorage.setItem("op_sid", Math.random().toString(36).slice(2));
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem("op_utm") || "{}");
  } catch (e) {
    return {};
  }
}

export function track(type) {
  api.post("/events", { type, path: window.location.pathname, utm: getUtm(), session_id: sessionStorage.getItem("op_sid") || "" }).catch(() => {});
}

export const money = (n) => `$${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
